<h2 class="center-page-heading">{{ "settings_layer_page_heading" | translate }}</h2>
<p class="center-page-description">{{ "settings_layer_layersettings_description" | translate }}</p>

<p-card class="mt-6 p-4 pb-0">
    <div class="grid grid-cols-12 gap-4 gap-6">
        <div class="col-span-12 md:col-span-12 xl:col-span-8 mx-2 my-4">
            <p-table [lazy]="true" [loading]="isLoading" [value]="layers" responsiveLayout="scroll" editMode="row" dataKey="index">
                <ng-template pTemplate="body" let-layer let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="layer" [attr.data-testid]="'layer-settings-row-' + layer.index">
                        <td>
                            <h6 style="margin: 0 !important">{{ "settings_layer_title" | translate }} {{ layer.index }}</h6>
                        </td>
                        <td>
                            @if (layer.index != 1) {
                                <p-selectButton
                                    [attr.data-testid]="'layer-visibility-' + layer.index"
                                    [allowEmpty]="false"
                                    [disabled]="isSelectButtonDisabled(layer) || (layer.index == 3 && !isPro)"
                                    (onChange)="toggleLayerVisibility(layer, $event.value)"
                                    [options]="stateOptions"
                                    [ngModel]="layer.visible"
                                    optionLabel="label"
                                    optionValue="value"
                                    pTooltip="{{ 'settings_layer_proFeature_layer' | translate }}"
                                    tooltipPosition="top"
                                    [tooltipDisabled]="isPro"
                                />
                            }
                        </td>
                        <td>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input #asdf pInputText type="text" class="layer-name-input" [ngModel]="layer.name" (ngModelChange)="updateName($event)" />
                                </ng-template>
                                <ng-template pTemplate="output"> {{ layer.name }} </ng-template>
                            </p-cellEditor>
                        </td>
                        <td style="text-align: center">
                            <div
                                pTooltip="{{ 'settings_layer_proFeature_title' | translate }}"
                                [tooltipDisabled]="isPro"
                                tooltipPosition="top"
                                style="display: inline-block"
                            >
                                <button
                                    *ngIf="!editing"
                                    pButton
                                    pRipple
                                    type="button"
                                    pInitEditableRow
                                    icon="pi pi-pencil"
                                    (click)="onRowEditInit(layer)"
                                    class="p-button-rounded p-button-text"
                                    [disabled]="!isPro"
                                    [attr.data-testid]="'layer-edit-' + layer.index"
                                ></button>
                            </div>
                            <div
                                pTooltip="{{ 'settings_layer_proFeature_title' | translate }}"
                                [tooltipDisabled]="isPro"
                                tooltipPosition="top"
                                style="display: inline-block"
                            >
                                @if (editing) {
                                    <button
                                        pButton
                                        severity="success"
                                        pRipple
                                        type="button"
                                        pSaveEditableRow
                                        (click)="onRowEditSave(layer)"
                                        [disabled]="!isPro"
                                        class="p-button-rounded p-button-text mr-2"
                                        [attr.data-testid]="'layer-save-' + layer.index"
                                    >
                                        <i class="pi pi-check"></i>
                                    </button>
                                }
                            </div>
                            <div
                                pTooltip="{{ 'settings_layer_proFeature_title' | translate }}"
                                [tooltipDisabled]="isPro"
                                tooltipPosition="top"
                                style="display: inline-block"
                            >
                                @if (editing) {
                                    <button
                                        pButton
                                        severity="danger"
                                        pRipple
                                        type="button"
                                        pCancelEditableRow
                                        (click)="onRowEditCancel(layer, ri)"
                                        [disabled]="!isPro"
                                        class="p-button-rounded p-button-text"
                                        [attr.data-testid]="'layer-cancel-' + layer.index"
                                    >
                                        <i class="pi pi-times"></i>
                                    </button>
                                }
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="col-span-6"></div>
    </div>
    <p-message severity="info" text="{{ 'settings_layer_restart_info' | translate }}" styleClass="mr-2 mb-6"></p-message>
</p-card>

<div class="mt-12">
    <h3 class="tb-h5">{{ "settings_layer_examples_heading" | translate }}</h3>
    <p>{{ "settings_layer_examples_description" | translate }}</p>
    <p-chip label="{{ 'settings_layer_example_clients' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_projects' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_customers' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_cases' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_tasks' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_activities' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <br />
    <p-chip label="{{ 'settings_layer_example_cost centers' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_issues' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_tickets' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_work-steps' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_working-phases' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <br />
    <p-chip label="{{ 'settings_layer_example_construction-phases' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_regions' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_product-id' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_department' | translate }}" styleClass="mr-2 mb-2"></p-chip>
    <p-chip label="{{ 'settings_layer_example_sub-projects' | translate }}" styleClass="mr-2 mb-2"></p-chip>
</div>
